import Login from "./views/Login";
import Home from "./views/Home";
import ForgotPassword from "./views/ForgotPassword";
import AgendaPage from "./views/AgendaPage";
import PrivacyPolicy from "./views/PrivacyPolicy";

export const routes = [
  // {
  //   path: "/index",
  //   name: "Página Inicial",
  //   icon: "fa fa-home text-gray",
  //   component: <Home />,
  //   layout: "/admin",
  // },
  {
    path: "/index",
    name: "Agenda",
    icon: "fa fa-calendar text-gray",
    component: <AgendaPage />,
    layout: "/admin",
  },
  {
    path: "/privacy",
    name: "Política de Privacidade",
    icon: "ni ni-lock-circle-open text-gray",
    component: <PrivacyPolicy />,
    layout: "/admin",
  },
  {
    path: "/login",
    name: "Sair",
    icon: "ni ni-key-25 text-gra",
    component: <Login />,
    layout: "/auth",
  },
  // {
  //   path: "/forgot-password",
  //   name: "Esqueceu a Senha",
  //   icon: "ni ni-lock-circle-open text-gray",
  //   component: <ForgotPassword />,
  //   layout: "/auth",
  // },
];

export const routesAdmin = [
  {
    path: "/login",
    name: "Sair",
    icon: "ni ni-key-25 text-gray",
    component: <Login />,
    layout: "/auth",
  },
];
